import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createSystemRole($data: createSystemRoleInput!) {
    createSystemRole(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createSystemRoleRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateSystemRoleInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_role/create_system_role',
  async (params: {data: TYPES.CreateSystemRoleInput;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createSystemRole;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createSystemRoleSlice = createSlice({
  name: 'create_system_role',
  initialState: initialState,
  reducers: {
    createSystemRoleClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createSystemRoleRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(createSystemRoleRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(createSystemRoleRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { createSystemRoleClear } = createSystemRoleSlice.actions;

export const createSystemRole = createSelector(
  (state: RootState) => state.systemRole.createSystemRole.result,
  (state: RootState) => state.systemRole.createSystemRole.error,
  (state: RootState) => state.systemRole.createSystemRole.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createSystemRoleSlice.reducer;